export function compare<T>(a: T, b: T, desc = false) {
    const sign = desc ? -1 : 1;
    return sign * (a < b ? -1 : a > b ? 1 : 0);
}

export function compareProps(
    a: Record<string, unknown>,
    b: Record<string, unknown>,
    props: string | string[],
    desc = false
) {
    props = Array.isArray(props) ? props : [props];

    let result = 0;

    while (!result && props.length) {
        const p = props.shift()!;
        result = compare(a[p], b[p], desc);
    }

    return result;
}

export function comparePropsFn(props: string | string[], desc = false) {
    return (a: Record<string, unknown>, b: Record<string, unknown>) => compareProps(a, b, props, desc);
}